<script>
export default {
  computed: {
    dashboard_type() {
      return this.$route.query.dashboard_type || 'admin'
    },
  },
}
</script>

<template>
  <ul class="nav-wrap">
    <li>
      <router-link
        :to="{ name: 'login-me' }"
        :class="{ active: dashboard_type === 'admin' }"
        >{{ $t('admin.cmd_admin_page') }}</router-link
      >
    </li>
    <li>
      <router-link
        :to="{ name: 'login-me', query: { dashboard_type: 'brokerage' } }"
        :class="{ active: dashboard_type === 'brokerage' }"
        >{{ $t('admin.cmd_brokerage_page') }}</router-link
      >
    </li>
  </ul>
</template>

<style lang="scss" module>
@import '@design';
</style>
<style scoped>
.nav-wrap {
  display: flex;
}
.nav-wrap li {
  width: 50%;
  border-bottom: 1px solid #63bc90;
}
.nav-wrap li a {
  display: block;
  width: 100%;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: rgb(94, 108, 117);
  text-align: center;
  background-color: white;
}
.nav-wrap li a.active {
  color: #fff;
  background: #63bc90;
}
</style>
